import {
    IWarehouse,
    IWarehouseItem,
    WarehouseItemResponseType,
    WarehouseResponseType } from '@/entity/warehouse/Warehouse.types'

import { RequestType } from '@/form/form.types';

export class Warehouse implements IWarehouse {
    total: number;
    data : Array<IWarehouseItem>=[];

    constructor (data: WarehouseResponseType){
        this.total = data.total;
        console.log('warehouse total ='+this.total)

        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}
export class WarehouseItem implements IWarehouseItem {
    id:number;
    comment: string;
    created_at: string;
    name: string;
    product_count: number;
    salon_id: number;
    type_id: number;
    type_name: string;
    updated_at: string;
    constructor(data:WarehouseItemResponseType) {
        this.id = data.id;
        this.comment = data.comment;
        this.created_at = data.created_at;
        this.name = data.name
        this.product_count = data.product_count
        this.salon_id = data.salon_id;
        this.type_id = data.type_id
        this.type_name = data.type_name
        this.updated_at = data.updated_at
    }
}
export type WarehouseAddRequestType = RequestType & {
    name: string;
    salon_id: number | null;
    type_id: number | null;
    comment: string;
}
export type WarehouseUpdateRequestType = RequestType & {
    id?: number | null;
    name: string;
    type_id: number | null;
    salon_id: number | null;
    comment: string;
}
